import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { Grid, Typography } from "components/controls/widget";
import rootPath, { RouteProps } from "./routes-path";
import PageTitle from "common/web/PageTitle";
import PageHeader from "common/web/PageHeader";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { useClub } from "../../../../clubs/club/store";
import { ClubMemberApplications } from "../../../../application/club_member_applications/view";

type Props = RouteComponentProps<RouteProps> & WithStyles<typeof styles>;


const styles = () => createStyles({
    grow: {
        flexGrow: 1,
    },
    title: {
        fontSize: 24,
        marginTop: 20,
        marginBottom: 10,
        paddingLeft: 12,
        paddingRight: 12,
    },
    menu: {
        backgroundColor: 'aliceblue',
        paddingLeft: 0,
        paddingRight: 12,
        display: 'flex',
        marginBottom: 10,
    },
    menuItem: {
        float: 'left',
        display: 'inline-flex',
    },
    menuItemA: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 10,
        paddingBottom: 10,
        color: '#337ab7',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#eee',
        },
    },

    menuItemASel: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 10,
        paddingBottom: 10,
        color: '#337ab7',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#eee',
        },
        borderBottom: '3px solid #000',
    },
});


const View = (props: Props) => {

    const { classes, match } = props;
    const { clubId, lang } = match.params;
    const link1 = `/${lang}/Kluby/Detail/${clubId}`
    const link2 = `/${lang}/evidence-klubu/detailni-udaje-klubu/${clubId}`

    const [{ entity, loading, loadFailure, errors }, { loadClub }] = useClub();

    React.useEffect(() => {
        loadClub(Number(clubId))
    }, []);


    const showDetail = !loading && !loadFailure && entity != null;

    return <div>
        <PageTitle title="Detailní údaje klubu" />
        <div>
            <div className={classes.title}>
                {entity?.divisionNumber} - {entity?.clubNumber} {entity?.name}
            </div>

            <div className={classes.menu}>
                <span className={classes.menuItem}>
                    <a href={link1} className={classes.menuItemA}>Základní údaje</a>
                </span>

                <span className={classes.menuItem}>
                    <a href={link2 + "/prestupy"} className={classes.menuItemA}>Přestupy</a>
                </span>

                <span className={classes.menuItem}>
                    <a href={link2 + "/hostovani-dlouhodoba"} className={classes.menuItemA}>Hostování dlouhodobá</a>
                </span>

                <span className={classes.menuItem}>
                    <a href="#" className={classes.menuItemASel}>Přihlášky členů do ČSTS</a>
                </span>

                <span className={classes.menuItem}>
                    <a href={link2 + "/pary"} className={classes.menuItemA}>Seznam párů</a>
                </span>

            </div>
        </div>
        <div>
            {showDetail && <ClubMemberApplications clubID={Number(clubId)} />}
        </div>
    </div >
}

const DecoratedView = withRouter(withStyles(styles)(View));

export {
    DecoratedView as ClubView
}